import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const allMembers = [
  { name: 'Member 1', website: 'www.member1.com', logo: 'https://placehold.co/300x150/F8F7F3/0F1C35?text=M1' },
  { name: 'Member 2', website: 'www.member2.com', logo: 'https://placehold.co/300x150/F8F7F3/0F1C35?text=M2' },
  { name: 'Member 3', website: 'www.member3.com', logo: 'https://placehold.co/300x150/F8F7F3/0F1C35?text=M3' },
  { name: 'Member 4', website: 'www.member4.com', logo: 'https://placehold.co/300x150/F8F7F3/0F1C35?text=M4' },
  { name: 'Member 5', website: 'www.member5.com', logo: 'https://placehold.co/300x150/F8F7F3/0F1C35?text=M5' },
  { name: 'Member 6', website: 'www.member6.com', logo: 'https://placehold.co/300x150/F8F7F3/0F1C35?text=M6' },
  { name: 'Member 7', website: 'www.member7.com', logo: 'https://placehold.co/300x150/F8F7F3/0F1C35?text=M7' },
  { name: 'Member 8', website: 'www.member8.com', logo: 'https://placehold.co/300x150/F8F7F3/0F1C35?text=M8' },
  { name: 'Member 9', website: 'www.member9.com', logo: 'https://placehold.co/300x150/F8F7F3/0F1C35?text=M9' },
  { name: 'Member 10', website: 'www.member10.com', logo: 'https://placehold.co/300x150/F8F7F3/0F1C35?text=M10' },
  { name: 'Member 11', website: 'www.member11.com', logo: 'https://placehold.co/300x150/F8F7F3/0F1C35?text=M11' },
  { name: 'Member 12', website: 'www.member12.com', logo: 'https://placehold.co/300x150/F8F7F3/0F1C35?text=M12' },
];

const displayMembers = allMembers.slice(0, 6);

// --- Shared Reveal Logic ---
function useReveal() {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.querySelectorAll<HTMLElement>('[data-r]').forEach((node, i) => {
            setTimeout(() => {
              node.style.opacity = '1';
              node.style.transform = 'translateY(0) translateX(0)';
            }, i * 120);
          });
          obs.disconnect();
        }
      },
      { threshold: 0.1 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);
  return ref;
}

const hide = (dir: 'up' | 'left' | 'right' = 'up'): React.CSSProperties => ({
  opacity: 0,
  transform:
    dir === 'up' ? 'translateY(28px)'
    : dir === 'left' ? 'translateX(-32px)'
    : 'translateX(32px)',
  transition: 'opacity 0.8s ease, transform 0.8s ease',
});
// ---------------------------

export default function MembersSection() {
  const sectionRef = useReveal();
  const navigate = useNavigate();

  return (
    <section id="members" className="py-20 md:py-20 font-sans" style={{ backgroundColor: '#F8F7F3' }}>
      <div ref={sectionRef} className="w-full px-6 md:px-10 lg:px-16 xl:px-24 max-w-[1400px] mx-auto">
        
        {/* Section Header */}
        <div className="max-w-3xl mx-auto text-center mb-14 flex flex-col items-center">
          <h2 
            data-r 
            style={{
              ...hide('up'),
              color: '#0F1C35',
              fontSize: 'clamp(2rem, 4vw, 3rem)',
              fontWeight: 800,
              letterSpacing: '-0.02em',
              marginBottom: '16px'
            }}
          >
            Member Companies
          </h2>
          <p 
            data-r 
            style={{ ...hide('up'), color: '#3D4A62' }}
            className="text-base md:text-lg leading-relaxed"
          >
            Representing the leading businesses driving Italy-Bangladesh commerce.
          </p> 
        </div>

        <div className='flex h-[70%] justify-center items-center'>
          <h1 className='text-2xl font-bold'>Members update are coming soon</h1>
        </div>

        {/* Members Grid */}
        

        {/* View All Button */}
        {/* <div data-r style={hide('up')} className="text-center">
          <button
            onClick={() => navigate('/members')}
            className="inline-flex items-center gap-2 px-8 py-3.5 text-sm font-bold rounded-lg transition-all cursor-pointer shadow-md hover:shadow-lg group"
            style={{ 
              backgroundColor: '#C9952A',
              color: '#FFFFFF'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = '#0F1C35';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = '#C9952A';
            }}
          >
            View All Members
            <svg className="w-4 h-4 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </button>
        </div> */}

      </div>
    </section>
  );
}



{/* <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 mb-12">
          {displayMembers.map((m, i) => (
            <div
              key={i}
              data-r
              className="bg-white rounded-2xl p-8 border flex flex-col items-center justify-center text-center transition-all duration-300"
              style={{ 
                ...hide('up'),
                borderColor: '#E5E7EB',
                boxShadow: '0 4px 20px rgba(15, 28, 53, 0.03)'
              }}
            >
              {/* Partner Logo */}
              // <div className="h-20 w-full flex items-center justify-center mb-6">
              //   <img 
              //     src={m.logo} 
              //     alt={`${m.name} logo`} 
              //     className="max-h-full max-w-full object-contain"
              //   />
              // </div>
              
              {/* Company Name */}
              // <h4 
              //   className="font-bold text-lg mb-3"
              //   style={{ color: '#0F1C35' }}
              // >
              //   {m.name}
              // </h4>

              {/* Website Link */}
              // <a 
              //   href={`https://${m.website.replace(/^https?:\/\//, '')}`} 
              //   target="_blank" 
              //   rel="noreferrer"
              //   className="text-sm font-medium hover:underline flex items-center gap-2"
              //   style={{ color: '#C9952A' }}
              // >
              //   <i className="ri-global-line"></i>
              //   {m.website.replace(/^https?:\/\//, '')}
              // </a>
        //     </div>
        //   ))}
        // </div> */}